import React from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';

// Search-first toolbar. Common actions (refresh, excel) are direct buttons next
// to the search; bulk operations live in the contextual selection bar.
export default function ProductToolbar({ t, globalFilter, onGlobalFilter, onAdd, onRefresh, onExcel, viewMode, onViewMode, addButton }) {
  return (
    <div style={{ display:'flex', gap:12, flexWrap:'wrap', alignItems:'center', marginBottom:12 }}>
      {addButton !== undefined
        ? addButton
        : <Button icon="pi pi-plus" label={t('product.add_product')} className="p-button-success" data-tour="step4" onClick={onAdd} />
      }
      <span className="p-input-icon-left" style={{ flex:'1 1 240px', maxWidth:380 }}>
        <i className="pi pi-search" />
        <InputText value={globalFilter || ''} onChange={onGlobalFilter} style={{ width:'100%' }} placeholder={t('product.globalFilter')} />
      </span>
      <Button icon="pi pi-refresh" label={t('actions.refresh')} className="p-button-outlined" onClick={onRefresh}
              tooltip={t('actions.refresh')} tooltipOptions={{position:'bottom'}} />
      <Button icon="pi pi-file-excel" label={t('actions.excel')} className="p-button-outlined p-button-success" data-tour="step3"
              onClick={(e) => onExcel(e)} tooltip={t('actions.excel')} tooltipOptions={{position:'bottom'}} />
      <span className="p-buttonset pux-viewtoggle" style={{ marginLeft:'auto' }}>
        <Button icon="pi pi-table" label={t('toolbar.table_view')} className={viewMode === 'table' ? 'p-button-sm p-button-help' : 'p-button-sm p-button-help p-button-outlined'} onClick={() => onViewMode('table')} tooltip={t('toolbar.table_view')} tooltipOptions={{position:'bottom'}} />
        <Button icon="pi pi-th-large" label={t('toolbar.card_view')} className={viewMode === 'card' ? 'p-button-sm p-button-help' : 'p-button-sm p-button-help p-button-outlined'} onClick={() => onViewMode('card')} tooltip={t('toolbar.card_view')} tooltipOptions={{position:'bottom'}} />
      </span>
    </div>
  );
}
